<header 
  class="p-2 pb-4 border-bottom header-shadow header"
  [ngClass]="{'bg-gradient': isProfilePage}"
>
  <div class="">
    <div class="row">
      <div class="col-md-12 text-end">
        <div class="dropdown user-dropdown" (click)="$event.stopPropagation()">
          <span
            [hidden]="!auth.isApprover()"
            class="mx-4"
            [ngClass]="{'header_title': !isProfilePage, 'header_title_gradient': isProfilePage}"
            [title]="'Balance in ' + displayCurrency + ' · settled in KES'"
            >{{ displayCurrency }} {{ convertedBalance | number : "2.0-1" }}</span
          >

          <!--<img src="./assets/Menu sections/filter/flag-of-the-united-states-computer-icons-usa-gerb-24f7b05b1b2bdd5109fe660fbe8a9c83 1.png"
                        alt="">-->
          <!--<img class="mx-4" src="./assets/Menu sections/features/Component 27.png" alt="">-->
          <!-- Dark / light theme toggle -->
          <button class="theme-toggle-btn mx-3" (click)="themeService.toggle()"
            [attr.aria-label]="themeService.isDark ? 'Switch to light mode' : 'Switch to dark mode'"
            [title]="themeService.isDark ? 'Light mode' : 'Dark mode'">
            <!-- Moon — shown in light mode, click to go dark -->
            <svg *ngIf="!themeService.isDark" width="18" height="18" viewBox="0 0 24 24" fill="none">
              <path d="M21 12.79A9 9 0 1111.21 3a7 7 0 009.79 9.79z"
                stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <!-- Sun — shown in dark mode, click to go light -->
            <svg *ngIf="themeService.isDark" width="18" height="18" viewBox="0 0 24 24" fill="none">
              <circle cx="12" cy="12" r="4" stroke="currentColor" stroke-width="1.8"/>
              <path d="M12 2v2M12 20v2M4.22 4.22l1.42 1.42M18.36 18.36l1.42 1.42M2 12h2M20 12h2M4.22 19.78l1.42-1.42M18.36 5.64l1.42-1.42"
                stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
            </svg>
          </button>

          <img src="./assets/Menu sections/icons/Rectangle 1058.png" alt="" />
          <button
            class="btn dropdown-toggle header_dropdown"
            type="button"
            id="dropdownMenuButton1"
            [attr.aria-expanded]="showDropdown"
            (click)="toggleDropdown($event)"
          >
            {{ user.first_name + " " + user.last_name }}
            <img class="mx-3" src="./assets/images/dropdown.png" alt="" />
          </button>
          <ul 
            class="dropdown-menu user-dropdown-menu" 
            aria-labelledby="dropdownMenuButton1"
            *ngIf="showDropdown"
          >
            <li><a class="dropdown-item" (click)="logout()">Logout</a></li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</header>
